// Crop name translations keyed by locale code.
// English keys match both the full CROPS array in App.js and the shorter CROPS_LIST in Dashboard.js.
// Sources: FAO Multilingual Thesaurus (AGROVOC), CGIAR crop names.
export const CROP_NAMES = {
  es: {
    // Short Dashboard aliases
    "Wheat":"Trigo","Maize":"Maíz","Rice":"Arroz","Beans":"Frijoles",
    "Tomato":"Tomate","Onion":"Cebolla","Grape":"Uva","Groundnut":"Maní / Cacahuete",
    // Full CROPS entries
    "Artichoke":"Alcachofa","Asparagus":"Espárrago","Beet (table)":"Remolacha de mesa",
    "Broccoli":"Brócoli","Brussels Sprouts":"Coles de Bruselas","Cabbage":"Repollo",
    "Cantaloupe":"Cantalupo","Carrot":"Zanahoria","Cauliflower":"Coliflor",
    "Celery":"Apio","Cucumber":"Pepino","Eggplant":"Berenjena","Garlic":"Ajo",
    "Kale":"Col rizada","Leek":"Puerro","Lettuce":"Lechuga","Okra":"Okra",
    "Onion (dry)":"Cebolla seca","Onion (green)":"Cebolla verde","Peas (fresh)":"Guisantes frescos",
    "Sweet Pepper":"Pimiento dulce","Pumpkin / Winter Squash":"Calabaza",
    "Radish":"Rábano","Spinach":"Espinaca","Squash (summer/zucchini)":"Calabacín",
    "Sweet Corn":"Maíz dulce","Swiss Chard":"Acelga","Tomato (fresh)":"Tomate fresco",
    "Tomato (processing)":"Tomate industrial","Turnip":"Nabo","Watermelon":"Sandía",
    "Cassava":"Yuca / Mandioca","Potato":"Papa / Patata","Sweet Potato":"Batata",
    "Yam":"Ñame","Bean (dry)":"Frijol seco","Bean (green/snap)":"Ejote / Habichuela",
    "Chickpea":"Garbanzo","Cowpea":"Caupí","Fava Bean":"Haba",
    "Groundnut / Peanut":"Maní / Cacahuete","Lentil":"Lenteja","Soybean":"Soya",
    "Barley":"Cebada","Corn / Maize":"Maíz","Millet":"Mijo","Oat":"Avena",
    "Quinoa":"Quinua","Rice (paddy)":"Arroz (con cáscara)","Rye":"Centeno",
    "Sorghum":"Sorgo","Wheat (winter)":"Trigo de invierno","Wheat (spring)":"Trigo de primavera",
    "Canola / Rapeseed":"Canola / Colza","Cotton":"Algodón","Flax / Linseed":"Lino",
    "Safflower":"Cártamo","Sesame":"Sésamo / Ajonjolí","Sunflower":"Girasol",
    "Sugarcane":"Caña de azúcar","Sugar Beet":"Remolacha azucarera",
    "Avocado":"Aguacate","Banana":"Plátano / Banano","Citrus (orange)":"Naranja",
    "Citrus (lemon/lime)":"Limón / Lima","Coconut":"Coco","Coffee":"Café",
    "Mango":"Mango","Papaya":"Papaya","Pineapple":"Piña","Tea":"Té",
    "Almond":"Almendra","Apple":"Manzana","Apricot":"Albaricoque","Cherry":"Cereza",
    "Olive":"Olivo","Peach / Nectarine":"Durazno / Melocotón","Pear":"Pera",
    "Pistachio":"Pistacho","Plum / Prune":"Ciruela","Walnut":"Nuez",
    "Blueberry":"Arándano","Grape (table)":"Uva de mesa","Grape (wine)":"Uva vinera",
    "Raspberry":"Frambuesa","Strawberry":"Fresa",
    "Alfalfa (multi-cut)":"Alfalfa","Bermuda Grass":"Pasto bermuda",
    "Clover":"Trébol","Ryegrass / Pasture":"Raigrás / Pastizal",
    "Basil":"Albahaca","Cilantro / Coriander":"Cilantro","Hemp / Cannabis":"Cáñamo",
    "Hops":"Lúpulo","Mint":"Menta","Tobacco":"Tabaco"
  },
  fr: {
    "Wheat":"Blé","Maize":"Maïs","Rice":"Riz","Beans":"Haricots",
    "Tomato":"Tomate","Onion":"Oignon","Grape":"Raisin","Groundnut":"Arachide",
    "Artichoke":"Artichaut","Asparagus":"Asperge","Beet (table)":"Betterave rouge",
    "Broccoli":"Brocoli","Brussels Sprouts":"Choux de Bruxelles","Cabbage":"Chou",
    "Cantaloupe":"Cantaloup","Carrot":"Carotte","Cauliflower":"Chou-fleur",
    "Celery":"Céleri","Cucumber":"Concombre","Eggplant":"Aubergine","Garlic":"Ail",
    "Kale":"Chou frisé","Leek":"Poireau","Lettuce":"Laitue","Okra":"Gombo",
    "Onion (dry)":"Oignon sec","Onion (green)":"Oignon vert","Peas (fresh)":"Petits pois",
    "Sweet Pepper":"Poivron doux","Pumpkin / Winter Squash":"Courge / Citrouille",
    "Radish":"Radis","Spinach":"Épinard","Squash (summer/zucchini)":"Courgette",
    "Sweet Corn":"Maïs doux","Swiss Chard":"Bette / Blette","Tomato (fresh)":"Tomate fraîche",
    "Tomato (processing)":"Tomate industrielle","Turnip":"Navet","Watermelon":"Pastèque",
    "Cassava":"Manioc","Potato":"Pomme de terre","Sweet Potato":"Patate douce",
    "Yam":"Igname","Bean (dry)":"Haricot sec","Bean (green/snap)":"Haricot vert",
    "Chickpea":"Pois chiche","Cowpea":"Niébé","Fava Bean":"Fève",
    "Groundnut / Peanut":"Arachide","Lentil":"Lentille","Soybean":"Soja",
    "Barley":"Orge","Corn / Maize":"Maïs","Millet":"Mil","Oat":"Avoine",
    "Quinoa":"Quinoa","Rice (paddy)":"Riz paddy","Rye":"Seigle",
    "Sorghum":"Sorgho","Wheat (winter)":"Blé tendre d'hiver","Wheat (spring)":"Blé de printemps",
    "Canola / Rapeseed":"Colza","Cotton":"Coton","Flax / Linseed":"Lin",
    "Safflower":"Carthame","Sesame":"Sésame","Sunflower":"Tournesol",
    "Sugarcane":"Canne à sucre","Sugar Beet":"Betterave sucrière",
    "Avocado":"Avocat","Banana":"Banane","Citrus (orange)":"Orange",
    "Citrus (lemon/lime)":"Citron / Lime","Coconut":"Noix de coco","Coffee":"Café",
    "Mango":"Mangue","Papaya":"Papaye","Pineapple":"Ananas","Tea":"Thé",
    "Almond":"Amande","Apple":"Pomme","Apricot":"Abricot","Cherry":"Cerise",
    "Olive":"Olivier","Peach / Nectarine":"Pêche / Nectarine","Pear":"Poire",
    "Pistachio":"Pistache","Plum / Prune":"Prune","Walnut":"Noix",
    "Blueberry":"Myrtille","Grape (table)":"Raisin de table","Grape (wine)":"Raisin de cuve",
    "Raspberry":"Framboise","Strawberry":"Fraise",
    "Alfalfa (multi-cut)":"Luzerne","Bermuda Grass":"Chiendent pied-de-poule",
    "Clover":"Trèfle","Ryegrass / Pasture":"Ray-grass / Pâturage",
    "Basil":"Basilic","Cilantro / Coriander":"Coriandre","Hemp / Cannabis":"Chanvre",
    "Hops":"Houblon","Mint":"Menthe","Tobacco":"Tabac"
  },
  zh: {
    "Wheat":"小麦","Maize":"玉米","Rice":"水稻","Beans":"豆类",
    "Tomato":"番茄","Onion":"洋葱","Grape":"葡萄","Groundnut":"花生",
    "Artichoke":"朝鲜蓟","Asparagus":"芦笋","Beet (table)":"甜菜根",
    "Broccoli":"西兰花","Brussels Sprouts":"球芽甘蓝","Cabbage":"卷心菜",
    "Cantaloupe":"哈密瓜","Carrot":"胡萝卜","Cauliflower":"花椰菜",
    "Celery":"芹菜","Cucumber":"黄瓜","Eggplant":"茄子","Garlic":"大蒜",
    "Kale":"羽衣甘蓝","Leek":"大葱","Lettuce":"生菜","Okra":"秋葵",
    "Onion (dry)":"洋葱","Onion (green)":"青葱","Peas (fresh)":"鲜豌豆",
    "Sweet Pepper":"甜椒","Pumpkin / Winter Squash":"南瓜",
    "Radish":"萝卜","Spinach":"菠菜","Squash (summer/zucchini)":"西葫芦",
    "Sweet Corn":"甜玉米","Swiss Chard":"瑞士甜菜","Tomato (fresh)":"鲜番茄",
    "Tomato (processing)":"加工番茄","Turnip":"芜菁","Watermelon":"西瓜",
    "Cassava":"木薯","Potato":"土豆","Sweet Potato":"红薯",
    "Yam":"山药","Bean (dry)":"干豆","Bean (green/snap)":"四季豆",
    "Chickpea":"鹰嘴豆","Cowpea":"豇豆","Fava Bean":"蚕豆",
    "Groundnut / Peanut":"花生","Lentil":"扁豆","Soybean":"大豆",
    "Barley":"大麦","Corn / Maize":"玉米","Millet":"小米","Oat":"燕麦",
    "Quinoa":"藜麦","Rice (paddy)":"水稻","Rye":"黑麦",
    "Sorghum":"高粱","Wheat (winter)":"冬小麦","Wheat (spring)":"春小麦",
    "Canola / Rapeseed":"油菜","Cotton":"棉花","Flax / Linseed":"亚麻",
    "Safflower":"红花","Sesame":"芝麻","Sunflower":"向日葵",
    "Sugarcane":"甘蔗","Sugar Beet":"甜菜",
    "Avocado":"牛油果","Banana":"香蕉","Citrus (orange)":"橙子",
    "Citrus (lemon/lime)":"柠檬 / 青柠","Coconut":"椰子","Coffee":"咖啡",
    "Mango":"芒果","Papaya":"木瓜","Pineapple":"菠萝","Tea":"茶",
    "Almond":"杏仁","Apple":"苹果","Apricot":"杏子","Cherry":"樱桃",
    "Olive":"橄榄","Peach / Nectarine":"桃子 / 油桃","Pear":"梨",
    "Pistachio":"开心果","Plum / Prune":"李子","Walnut":"核桃",
    "Blueberry":"蓝莓","Grape (table)":"鲜食葡萄","Grape (wine)":"酿酒葡萄",
    "Raspberry":"覆盆子","Strawberry":"草莓",
    "Alfalfa (multi-cut)":"苜蓿","Bermuda Grass":"百慕大草",
    "Clover":"三叶草","Ryegrass / Pasture":"黑麦草 / 牧草",
    "Basil":"罗勒","Cilantro / Coriander":"香菜","Hemp / Cannabis":"大麻",
    "Hops":"啤酒花","Mint":"薄荷","Tobacco":"烟草"
  },
  hi: {
    "Wheat":"गेहूँ","Maize":"मक्का","Rice":"चावल","Beans":"फलियाँ",
    "Tomato":"टमाटर","Onion":"प्याज","Grape":"अंगूर","Groundnut":"मूंगफली",
    "Artichoke":"आटिचोक","Asparagus":"शतावरी","Beet (table)":"चुकंदर",
    "Broccoli":"ब्रोकली","Brussels Sprouts":"ब्रसेल्स स्प्राउट्स","Cabbage":"पत्तागोभी",
    "Cantaloupe":"खरबूजा","Carrot":"गाजर","Cauliflower":"फूलगोभी",
    "Celery":"अजमोद","Cucumber":"खीरा","Eggplant":"बैंगन","Garlic":"लहसुन",
    "Kale":"केल","Leek":"लीक","Lettuce":"सलाद पत्ता","Okra":"भिंडी",
    "Onion (dry)":"प्याज (सूखा)","Onion (green)":"हरा प्याज","Peas (fresh)":"ताजे मटर",
    "Sweet Pepper":"शिमला मिर्च","Pumpkin / Winter Squash":"कद्दू",
    "Radish":"मूली","Spinach":"पालक","Squash (summer/zucchini)":"तोरी / जुकीनी",
    "Sweet Corn":"मीठा मक्का","Swiss Chard":"स्विस चार्ड","Tomato (fresh)":"ताजा टमाटर",
    "Tomato (processing)":"प्रसंस्करण टमाटर","Turnip":"शलजम","Watermelon":"तरबूज",
    "Cassava":"कसावा","Potato":"आलू","Sweet Potato":"शकरकंद",
    "Yam":"रतालू","Bean (dry)":"सूखी फलियाँ","Bean (green/snap)":"हरी फलियाँ",
    "Chickpea":"चना","Cowpea":"लोबिया","Fava Bean":"बाकला",
    "Groundnut / Peanut":"मूंगफली","Lentil":"मसूर","Soybean":"सोयाबीन",
    "Barley":"जौ","Corn / Maize":"मक्का","Millet":"बाजरा","Oat":"जई",
    "Quinoa":"क्विनोआ","Rice (paddy)":"धान (चावल)","Rye":"राई",
    "Sorghum":"ज्वार","Wheat (winter)":"सर्दी गेहूँ","Wheat (spring)":"वसंत गेहूँ",
    "Canola / Rapeseed":"सरसों / कनोला","Cotton":"कपास","Flax / Linseed":"अलसी",
    "Safflower":"कुसुम","Sesame":"तिल","Sunflower":"सूरजमुखी",
    "Sugarcane":"गन्ना","Sugar Beet":"चुकंदर (चीनी)",
    "Avocado":"एवोकाडो","Banana":"केला","Citrus (orange)":"संतरा",
    "Citrus (lemon/lime)":"नींबू","Coconut":"नारियल","Coffee":"कॉफी",
    "Mango":"आम","Papaya":"पपीता","Pineapple":"अनानास","Tea":"चाय",
    "Almond":"बादाम","Apple":"सेब","Apricot":"खुबानी","Cherry":"चेरी",
    "Olive":"जैतून","Peach / Nectarine":"आड़ू","Pear":"नाशपाती",
    "Pistachio":"पिस्ता","Plum / Prune":"बेर / आलूबुखारा","Walnut":"अखरोट",
    "Blueberry":"ब्लूबेरी","Grape (table)":"अंगूर (खाने के)","Grape (wine)":"अंगूर (शराब)",
    "Raspberry":"रसभरी","Strawberry":"स्ट्रॉबेरी",
    "Alfalfa (multi-cut)":"रिजका / अल्फाल्फा","Bermuda Grass":"दूब घास",
    "Clover":"तिपतिया घास","Ryegrass / Pasture":"राईघास / चरागाह",
    "Basil":"तुलसी / बेसिल","Cilantro / Coriander":"धनिया","Hemp / Cannabis":"भांग",
    "Hops":"हॉप्स","Mint":"पुदीना","Tobacco":"तम्बाकू"
  },
  sw: {
    "Wheat":"Ngano","Maize":"Mahindi","Rice":"Mchele","Beans":"Maharagwe",
    "Tomato":"Nyanya","Onion":"Vitunguu","Grape":"Zabibu","Groundnut":"Karanga",
    "Artichoke":"Mchonga","Asparagus":"Asparagasi","Beet (table)":"Beet nyekundu",
    "Broccoli":"Brokoli","Brussels Sprouts":"Kabichi ndogo","Cabbage":"Kabichi",
    "Cantaloupe":"Tikiti maji","Carrot":"Karoti","Cauliflower":"Koliflawa",
    "Celery":"Selari","Cucumber":"Tango","Eggplant":"Bilinganya","Garlic":"Vitunguu saumu",
    "Kale":"Sukumawiki","Leek":"Liki","Lettuce":"Saladi","Okra":"Bamia",
    "Onion (dry)":"Vitunguu (vikavu)","Onion (green)":"Vitunguu maji","Peas (fresh)":"Njegere mbichi",
    "Sweet Pepper":"Pilipili hoho","Pumpkin / Winter Squash":"Malenge",
    "Radish":"Figili","Spinach":"Mchicha","Squash (summer/zucchini)":"Zukini",
    "Sweet Corn":"Mahindi matamu","Swiss Chard":"Chard","Tomato (fresh)":"Nyanya mbichi",
    "Tomato (processing)":"Nyanya za kiwanda","Turnip":"Tenipu","Watermelon":"Tikiti",
    "Cassava":"Muhogo","Potato":"Viazi","Sweet Potato":"Viazi vitamu",
    "Yam":"Mhogo mwitu","Bean (dry)":"Maharagwe (makavu)","Bean (green/snap)":"Maharagwe mabichi",
    "Chickpea":"Dengu","Cowpea":"Kunde","Fava Bean":"Pamba",
    "Groundnut / Peanut":"Karanga","Lentil":"Dengu za India","Soybean":"Soya",
    "Barley":"Shayiri","Corn / Maize":"Mahindi","Millet":"Mtama","Oat":"Shayiri laini",
    "Quinoa":"Quinoa","Rice (paddy)":"Mchele (mpunga)","Rye":"Rye",
    "Sorghum":"Mtama mkubwa","Wheat (winter)":"Ngano ya baridi","Wheat (spring)":"Ngano ya masika",
    "Canola / Rapeseed":"Canola","Cotton":"Pamba","Flax / Linseed":"Kitani",
    "Safflower":"Safflower","Sesame":"Ufuta","Sunflower":"Alizeti",
    "Sugarcane":"Miwa","Sugar Beet":"Beet ya sukari",
    "Avocado":"Parachichi","Banana":"Ndizi","Citrus (orange)":"Chungwa",
    "Citrus (lemon/lime)":"Ndimu","Coconut":"Nazi","Coffee":"Kahawa",
    "Mango":"Embe","Papaya":"Papai","Pineapple":"Nanasi","Tea":"Chai",
    "Almond":"Lozi","Apple":"Tofaa","Apricot":"Aprikoti","Cherry":"Cheri",
    "Olive":"Zeituni","Peach / Nectarine":"Pichi","Pear":"Pea",
    "Pistachio":"Pistashio","Plum / Prune":"Plamu","Walnut":"Walnut",
    "Blueberry":"Blueberry","Grape (table)":"Zabibu (kula)","Grape (wine)":"Zabibu (divai)",
    "Raspberry":"Rasiberi","Strawberry":"Stroroberi",
    "Alfalfa (multi-cut)":"Alfafa","Bermuda Grass":"Nyasi bermuda",
    "Clover":"Karafuu za shamba","Ryegrass / Pasture":"Nyasi / Malisho",
    "Basil":"Mrehani","Cilantro / Coriander":"Giligilani","Hemp / Cannabis":"Bangi",
    "Hops":"Hops","Mint":"Mnanaa","Tobacco":"Tumbaku"
  },
  ar: {
    "Wheat":"قمح","Maize":"ذرة","Rice":"أرز","Beans":"فاصوليا",
    "Tomato":"طماطم","Onion":"بصل","Grape":"عنب","Groundnut":"فول سوداني",
    "Artichoke":"خرشوف","Asparagus":"هليون","Beet (table)":"شمندر أحمر",
    "Broccoli":"بروكلي","Brussels Sprouts":"كرنب بروكسل","Cabbage":"ملفوف",
    "Cantaloupe":"شمام","Carrot":"جزر","Cauliflower":"قرنبيط",
    "Celery":"كرفس","Cucumber":"خيار","Eggplant":"باذنجان","Garlic":"ثوم",
    "Kale":"كيل","Leek":"كراث","Lettuce":"خس","Okra":"بامية",
    "Onion (dry)":"بصل جاف","Onion (green)":"بصل أخضر","Peas (fresh)":"بازلاء طازجة",
    "Sweet Pepper":"فليفلة حلوة","Pumpkin / Winter Squash":"قرع",
    "Radish":"فجل","Spinach":"سبانخ","Squash (summer/zucchini)":"كوسا",
    "Sweet Corn":"ذرة حلوة","Swiss Chard":"سلق","Tomato (fresh)":"طماطم طازجة",
    "Tomato (processing)":"طماطم صناعية","Turnip":"لفت","Watermelon":"بطيخ",
    "Cassava":"كسافا / مانيوك","Potato":"بطاطا","Sweet Potato":"بطاطا حلوة",
    "Yam":"يام","Bean (dry)":"فاصوليا جافة","Bean (green/snap)":"فاصوليا خضراء",
    "Chickpea":"حمص","Cowpea":"لوبيا","Fava Bean":"فول",
    "Groundnut / Peanut":"فول سوداني","Lentil":"عدس","Soybean":"فول الصويا",
    "Barley":"شعير","Corn / Maize":"ذرة","Millet":"دخن","Oat":"شوفان",
    "Quinoa":"كينوا","Rice (paddy)":"أرز (غير مقشور)","Rye":"جاودار",
    "Sorghum":"ذرة بيضاء","Wheat (winter)":"قمح شتوي","Wheat (spring)":"قمح ربيعي",
    "Canola / Rapeseed":"كانولا / لفت","Cotton":"قطن","Flax / Linseed":"كتان",
    "Safflower":"قرطم","Sesame":"سمسم","Sunflower":"عباد الشمس",
    "Sugarcane":"قصب السكر","Sugar Beet":"شمندر السكر",
    "Avocado":"أفوكادو","Banana":"موز","Citrus (orange)":"برتقال",
    "Citrus (lemon/lime)":"ليمون","Coconut":"جوز الهند","Coffee":"قهوة",
    "Mango":"مانغو","Papaya":"بابايا","Pineapple":"أناناس","Tea":"شاي",
    "Almond":"لوز","Apple":"تفاح","Apricot":"مشمش","Cherry":"كرز",
    "Olive":"زيتون","Peach / Nectarine":"خوخ","Pear":"إجاص",
    "Pistachio":"فستق","Plum / Prune":"برقوق","Walnut":"جوز",
    "Blueberry":"توت أزرق","Grape (table)":"عنب (للأكل)","Grape (wine)":"عنب (للنبيذ)",
    "Raspberry":"توت العليق","Strawberry":"فراولة",
    "Alfalfa (multi-cut)":"برسيم","Bermuda Grass":"عشب برمودا",
    "Clover":"برسيم","Ryegrass / Pasture":"جودة الحيوانات / مرعى",
    "Basil":"ريحان","Cilantro / Coriander":"كزبرة","Hemp / Cannabis":"قنب",
    "Hops":"قفزات","Mint":"نعناع","Tobacco":"تبغ"
  }
};

/** Returns the translated crop name for a given locale, falling back to English. */
export function tCrop(cropName, locale) {
  if (!locale || locale === "en") return cropName;
  return (CROP_NAMES[locale] && CROP_NAMES[locale][cropName]) || cropName;
}
